import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Category from "@/pages/Category";
import Product from "@/pages/Product";
import Articles from "@/pages/Articles";
import Article from "@/pages/Article";
import Search from "@/pages/Search";
import Season from "@/pages/Season";
import Page from "@/pages/Page";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/category/:slug" element={<Category />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/article/:slug" element={<Article />} />
              <Route path="/articles/:slug" element={<Article />} />
              <Route path="/search" element={<Search />} />
              <Route path="/page/:slug" element={<Page />} />
              <Route path="/season/:slug" element={<Season />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;
